import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {useForm} from 'react-hook-form'

import {
 useNavigate,
 useSearchParams,
} from 'react-router-dom'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import Spinner from 'layout/common/Spinner'
import {useTranslation} from 'react-i18next'
import {Select2DropdownField} from 'helpers/ui-components/form/Select2DropdownField'
import {KTSVG} from 'helpers/ui-components/KTSVG'
import {TextField} from 'helpers/ui-components/form/TextField'
import {IFormData} from 'models/Common'
import {userService} from 'utils/api/auth/authService'
import {setOTPData} from 'redux/slice/authSlice'
import {saveReturnUrl} from 'helpers/authRedirect'
// type Props = {}

const LoginPage = () => {
 const {t} = useTranslation()

 const dispatch = useDispatch()
 const navigate = useNavigate()
 const [searchParams] = useSearchParams()
 const [loader, setLoader] = useState(false)
 const loginForm = {
  mobileNumber: '',
  country: 'ind',
 }
 const {
  register,
  control,
  handleSubmit,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...loginForm},
 })
 const countryList = [
  {
   name: (
    <KTSVG
     path='/media/img/country/india.svg'
     svgClassName='w-[40px]'
    />
   ),
   alternate_name: 'India',
   value: 'ind',
  },
 ]

 useEffect(() => {
  const returnUrl = searchParams.get('returnUrl')
  if (returnUrl) {
   saveReturnUrl(returnUrl)
  }
 }, [searchParams])

 async function submitLoginFormData(formData: IFormData) {
  setLoader(true)
  const res = await userService.getOTP({
   phone_number: formData?.mobileNumber,
  })
  if (res) {
   dispatch(
    setOTPData({
     mobileNo: formData?.mobileNumber,
     userId: res,
    })
   )
   navigate('/otp-verification')
  }
  setLoader(false)
 }
 return (
  <>
   {loader && <Spinner />}
   <div className='container bg-white'>
    <div className='bg-white flex items-center justify-center min-h-full sm:pt-3 md:pt-14'>
     <form
      method='POST'
      action=''
      onSubmit={handleSubmit(submitLoginFormData)}
     >
      <div className='relative sm:w-full md:w-[360px] '>
       <div className='text-center'>
        <span className='text-[#33393D] text-2xl font-bold'>
         {t('loginPage.title')}
        </span>
       </div>
       <div className='relative w-full mt-8'>
        <Select2DropdownField
         className='image-selector relative m-0 block text-black text-xs w-[90px] border-0 font-semibold'
         wrapperClassName='absolute z-10 left-[1px] top-[1px] flex items-center !rounded-l-lg'
         inputWrapperClassName={`!rounded-l-lg !rounded-r-[0px]`}
         required={false}
         isClearable={false}
         isSearchable={false}
         control={control}
         customStyle={{
          borderColor: '#E6EBF0',
          border: '0px',
          borderTopLeftRadius: '8px',
          borderBottomLeftRadius: '8px',
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
          padding: '0px 8px 0px 0px',
          height: '60px',
          backgroundColor: '#E6EBF0',
         }}
         data={countryList}
         id={`country`}
         name={`country`}
         value={'en'}
         onChange={() => {
          // handleChangeLanguage(e.target.value)
         }}
         OptionValueKey='value'
         OptionLabelKey='name'
         placeholder={t('loginPage.country')}
        />
        <TextField
         type='text'
         maxLength={10}
         label={t('loginPage.mobileNoFieldLabel')}
         labelClassName='absolute z-10 top-[2px] padding-0 text-[#4E83E4] text-xs font-medium'
         className=''
         inputWrapperClassName='!pl-24 !py-[5px]'
         wrapperClassName='relative w-full'
         required={false}
         helperText={t('loginPage.mobileNoFieldHelperText')}
         id='mobileNumber'
         name='mobileNumber'
         placeholder={t('helperText.enterHere')}
         register={register('mobileNumber', {
          validate: {
           regex: (v: string) => {
            if (v !== '' && !v?.match('^[6-9][0-9]{9}$'))
             return `${t('helperText.plsEnterValid')} ${t(
              'loginPage.mobileNo'
             )}`
           },
           required: (v) => {
            if (v === '')
             return `${t('helperText.plsEnter')} ${t(
              'loginPage.mobileNo'
             )}`
           },
          },
         })}
         errors={errors}
        />
       </div>
       <div className='md:flex items-center justify-center w-full mt-8'>
        <Button
         disabled={errors && Object.keys(errors).length > 0}
         type='submit'
         color='blue'
         className='text-center w-full py-[9px] px-[24px] bg-[#4E83E4] 
                  !rounded-lg !text-base text-white font-semibold'
        >
         {t('loginPage.getOTP')}
        </Button>
       </div>
       <div className='my-10 flex items-center justify-center w-full border-t border-[#CED8E0] text-center'>
        <span className=' absolute inline-table bg-white px-[10px] py-0 text-base font-semibold text-[#5A6066]'>
         Or
        </span>
       </div>
       <div className='md:flex items-center justify-center w-full mt-8'>
        <Button
         onClick={() => window.open('someLink', '_blank')}
         color='blue'
         className='text-center w-full py-[9px] px-[24px] bg-gradient-to-r from-[#760C64] via-[#5E0C57] to-[#480B4E] 
                  !rounded-lg !text-base text-white font-semibold'
         icon={
          <div className='h-9 w-9 rounded-md bg-gradient-to-r from-[#965DE8] to-[#6558EE] absolute left-1'>
           <img
            src={'/media/img/filled-user.png'}
            className='m-auto '
            alt='CSC login'
            width='36'
            height='36'
           />
          </div>
         }
        >
         {t('loginPage.taskforceLogin')}
        </Button>
       </div>

       <div className='my-8 flex items-center justify-center w-full border-t border-[#CED8E0] text-center'></div>

       <div className='mb-8 text-center text-lg font-normal'>
        <span className='text-[#808080]'>
         {t('loginPage.newUser')}?{' '}
        </span>
        <button
         type='button'
         onClick={() => navigate('/register')}
         className='text-[#4E83E4] '
        >
         {t('loginPage.joinNow')}
        </button>
       </div>
      </div>
     </form>
    </div>
   </div>
  </>
 )
}

export default function LoginPageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 return (
  <>
   <LoginPage />
  </>
 )
}
